import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getWebStoriesByOrganization, getWebStoryDetails } from "./action";

export const webStoryEntityAdapter = createEntityAdapter({
  selectId: (webStory) => webStory._id,
});

const initialState = webStoryEntityAdapter.getInitialState({
  count: 0,
  allPreviousStoriesDetails: [],
});

export const webStorySlice = createSlice({
  name: "webStory",
  initialState,
  reducers: {
    resetState: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getWebStoryDetails.fulfilled, (state, action) => {
      if (action?.payload.success) {
        const webStory = action.payload.story;

        if (webStory && webStory.length > 0) {
          const updatedWebStory = {
            ...webStory[0],
            clips: webStory[0]?.clips?.map((clip) => ({
              ...clip,
              type: clip.type === "slate" ? "bumper" : clip.type,
            })),
          };

          webStoryEntityAdapter.setAll(state, [updatedWebStory]);
        } else {
          webStoryEntityAdapter.setAll(state, []);
        }
      } else {
        webStoryEntityAdapter.setAll(state, []);
      }
    });

    builder.addCase(getWebStoriesByOrganization.fulfilled, (state, action) => {
      if (action.payload.success) {
        const webStories = action.payload.stories.items || [];

        state.allPreviousStoriesDetails = webStories;
      }
    });
  },
});

export const { resetState } = webStorySlice.actions;

export default webStorySlice.reducer;
